import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Form,
  Message,
} from 'semantic-ui-react';
import _ from 'lodash';
import DyzioModal from 'dyzio-shared-components/lib/components/dyzio-modal';

const messageStyles = {
  width: '100%',
};
class ShopifyConnectionModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: {},
      ..._.get(props, 'connection', {}),
    };
  }
  onInputChanged = (event, { name, value, checked }) => {
    this.setState({
      [name]: value || checked,
    });
  }

  handleFormSubmit = e => {
    e.preventDefault();
    const { onSubmit } = this.props;

    this.setState({ error: null });
    const {
      shopifyAccessToken,
      shopifyShopUrl,
    } = this.state;

    const payload = {
      shopifyAccessToken,
      shopifyShopUrl,
    };

    const errors = _.reduce(_.keys(payload), (acc, key) => {
      const value = payload[key];
      const isValid = !_.isEmpty(value); // TODO: Implement validation
      if (!isValid) {
        acc[key] = 'Field is required';
      }
      return acc;
    }, {});
    this.setState({ errors });

    const isValid = _.isEmpty(errors);
    if (isValid) {
      onSubmit(payload);
    }
  }

  render() {
    const {
      onClose,
      isSubmitting,
      error,
    } = this.props;

    const {
      shopifyAccessToken,
      shopifyShopUrl,
      errors,
    } = this.state;
    const errorMessage = !_.isEmpty(error) && _.isString(error) ? error : 'Something went wrong. Please try again later.';
    return (
      <div>
        <DyzioModal headerText="Shopify connection" size="small" onClose={onClose}>
          <div >
            {error && (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                <Message
                  fluid
                  style={messageStyles}
                  icon="frown"
                  error
                  header="Error"
                  content={errorMessage}
                />
              </div>
            )}

            <Form onSubmit={this.handleFormSubmit}>
              <div style={{ maxHeight: '70vh', overflow: 'auto', margin: '1.5rem' }}>
                <Form.Field>
                  <label htmlFor="shopifyAccessToken">Access Token</label>
                  <Form.Input
                    error={Boolean(_.get(errors, 'shopifyAccessToken'))}
                    onChange={this.onInputChanged}
                    placeholder="Shopify Access Token"
                    name="shopifyAccessToken"
                    id="shopifyAccessToken"
                    value={shopifyAccessToken || ''}
                  />
                </Form.Field>
                <Form.Field>
                  <label htmlFor="shopifyShopUrl">Shop Url</label>
                  <Form.Input
                    error={Boolean(_.get(errors, 'shopifyShopUrl'))}
                    onChange={this.onInputChanged}
                    placeholder="Shopify Shop Url"
                    id="shopifyShopUrl"
                    name="shopifyShopUrl"
                    value={shopifyShopUrl || ''}
                  />
                </Form.Field>
              </div>
              <div
                className="flex"
                style={{
                  justifyContent: 'flex-end',
                  padding: '10px 0px 10px 0px',
                }}
              >
                <Form.Button
                  loading={isSubmitting}
                  disabled={isSubmitting}
                  color="pink"
                  type="submit"
                  size="medium"
                >
                Submit
                </Form.Button>
              </div>
            </Form>

          </div>
        </DyzioModal>
      </div>
    );
  }
}

ShopifyConnectionModal.propTypes = {
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
  isSubmitting: PropTypes.bool,
  error: PropTypes.any,
};
ShopifyConnectionModal.defaultProps = {
  onClose: _.noop,
  onSubmit: _.noop,
  isSubmitting: false,
  error: null,
};
export default ShopifyConnectionModal;



/** WEBPACK FOOTER **
 ** ./src/components/shopify-connection-modal/index.js
 **/